import * as Yup from 'yup';

export const selectVATModalValidationSchema = Yup.object({
  tax_rate: Yup.number()
    .typeError('VAT amount must be a number')
    .min(0, 'VAT amount must be between 0 and 100')
    .max(100, 'VAT amount must be between 0 and 100')
    .required('Required field'),
});
